import { State, Action, StateContext, Selector } from '@ngxs/store';
import { BorrowerOpportunityHistory } from '../../../models/dto/borrower-opportunity-history.model';
import { GetBorrowerOpportunityHistory, ClearBorrowerOpportunityHistory } from './borrower-opportunity-history.actions';
import { tap } from 'rxjs/operators';
import { ApiHttpClient } from '../../../http/clients/api';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';

const baseUrl = `${environment.API_URL}`;

export class BorrowerOpportunityHistoryModel {
	opportunityHistory: BorrowerOpportunityHistory[];
}

@State<BorrowerOpportunityHistoryModel>({
	name: 'opportunityHistory',
    defaults: {
		opportunityHistory: []
	}
})

@Injectable()

export class BorrowerOpportunityHistoryState {

    @Selector()
	static opportunityHistory(state: BorrowerOpportunityHistoryModel) {
        return state.opportunityHistory;
    }

    constructor(private http: ApiHttpClient) {}

    @Action(GetBorrowerOpportunityHistory)
    getBorrowerOpportunityHistory(
        { patchState }: StateContext<BorrowerOpportunityHistoryModel>,
        { borrowerId }: GetBorrowerOpportunityHistory
    ) {
        return this.http.get<BorrowerOpportunityHistory[]>(`${baseUrl}/borrower/${borrowerId}/opportunity-history`).pipe(tap(response => {
            patchState({ opportunityHistory: response });
        }));
    }

    @Action(ClearBorrowerOpportunityHistory)
    clearBorrowerOpportunityHistory({ patchState }: StateContext<BorrowerOpportunityHistoryModel>) {
        patchState({ opportunityHistory: [] });
    }
}
